import { render, staticRenderFns } from "./PaypalDirect.vue?vue&type=template&id=3bd11c78&scoped=true&"
import script from "./PaypalDirect.vue?vue&type=script&lang=js&"
export * from "./PaypalDirect.vue?vue&type=script&lang=js&"
import style0 from "./PaypalDirect.vue?vue&type=style&index=0&id=3bd11c78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd11c78",
  null
  
)

export default component.exports